// src/pages/misc/NoAccessPage.tsx
import { Box, Button, Typography } from '@mui/material';
import { useGetIdentity, useLogout } from 'react-admin';

export default function NoAccessPage() {
    const { identity } = useGetIdentity();
    const logout = useLogout();
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 2,
                mt: 12,
            }}
        >
            <Typography variant="h5">No access yet</Typography>
            <Typography variant="body2" color="text.secondary">
                Your account doesn&apos;t have access to this area yet.
            </Typography>
            {identity?.email ? (
                <Typography variant="caption" color="text.secondary">
                    Signed in as {identity.email}
                </Typography>
            ) : null}
            <Button variant="outlined" onClick={() => logout()}>
                Sign out
            </Button>
        </Box>
    );
}
